<div class="metrics-dialog">
  <div class="dialog-header">
    <div class="header-content">
      <mat-icon class="header-icon">bar_chart</mat-icon>
      <div class="header-text">
        <h2>Event Metrics</h2>
        <p class="event-title">{{ data.eventTitle }}</p>
        <span class="event-id" *ngIf="data.eventId">ID: #{{ data.eventId }}</span>
      </div>
    </div>
    <button class="close-button" (click)="close()" mat-icon-button aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-body">
    <div class="metrics-grid">
      <div class="metric-card" *ngFor="let metric of metrics">
        <div class="metric-icon-wrap">
          <mat-icon>{{ metric.icon }}</mat-icon>
        </div>
        <div class="metric-info">
          <span class="metric-label">{{ metric.label }}</span>
          <span class="metric-value">{{ metric.value | number }}</span>
          <span class="metric-sub">attendees</span>
        </div>
      </div>
    </div>
  </div>

  <div class="dialog-footer">
    <button class="close-btn" (click)="close()">Close</button>
  </div>
</div>
